{
	"descBoth": "This will remove all ratings and edit history, unhide all photos, reset the catalog (.catalog file) in the project folder. This cannot be undone.",
	"descEdits": "This will remove all edit history in the project folder. This cannot be undone.",
	"descRatings": "This will remove all ratings, unhide all photos, and reset the catalog (.catalog file) in the project folder. This cannot be undone.",
	"edits": "Edits",
	"failedToReset": "Failed to reset project",
	"ratingsLabelsFlags": "Ratings, labels and flags",
	"resetProject": "Reset Project",
	"resetting": "Resetting project...",
	"selectWhatToReset": "Select what to reset in the project"
}
